export default __webpack_public_path__ + "static/media/01_north_flower_a2.9acf2d16.mp4";